import { defineAction } from '~/prix'
import citizenFetchAnswers from './citizenFetchAnswers.action.json' with { type: 'json' }
import { z } from 'zod'

const citizenAnswerObject = z.object({
  questionId: z.number(),
  question: z.string(),
  parsedAnswer: z.string().nullish(),
  string: z.string().nullish(),
  boolean: z.boolean().nullish(),
  numeric: z.number().nullish(),
  array: z.array(z.string()).nullish(),
  date: z.coerce.date().nullish(),
  answerSheetId: z.union([z.number(), z.string().uuid()]),
  questionnaireId: z.number(),
  selectedOptions: z.array(
    z.object({
      id: z.number(),
      label: z.string(),
    }),
  ),
})

const citizenFetchAnswersDefinition = defineAction({
  ...citizenFetchAnswers,
  input: z.object({
    citizenId: z.string().uuid(),
    questionnaireId: z.coerce.number(),
  }),
  output: z.array(citizenAnswerObject),
})

export default citizenFetchAnswersDefinition
